module.exports = __webpack_public_path__ + "static/media/silestone.46245b38.svg";